import instance from '@/api/business'
import { Supplier } from '@/types/Supplier' 

export const fetchSupplier = async () => {
    const response = await instance.post<Supplier[]>('/supplier/cockpit/supplier')

    return response.data
}
 
